import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import PageStoreContext from "../context";
import { IPeriodOption } from "./periodsTab/data";
import { AggregationPeriod } from "../../../../../services/stats/models";
import { changeEventHandlerDecorator } from "../../../../../common/libs";
import { FormControl, Space, TextField, } from "../../../../../common/components/libs";
import { InputLabel, MenuItem, OutlinedInput, Select } from "@material-ui/core";
import { useStores } from "../../../../../hooks";
import { SnackbarType } from "../../../../../stores/common";
import {Trans, useTranslation} from "react-i18next";

const translate = (period, t) => {
    switch (period) {
        /*case AggregationPeriod.minutes:
            return t("general:minutes");*/
       /* case AggregationPeriod.hours:
            return t("general:hours");*/
        case AggregationPeriod.weeks:
            return t("general:weeks");
        case AggregationPeriod.days:
            return t("general:days");
        case AggregationPeriod.month:
            return t("general:months");
        default:
            return "";
    }
};

const AggregationIntervals = () => {
    const pageStore = useContext(PageStoreContext);
    const currentPeriod: IPeriodOption = pageStore.period;
    const {i18n, t} = useTranslation(["general", "stats"]);
    const locale = i18n.language;

    const { generalStore } = useStores()

    const [amount, setAmount] = useState(
        currentPeriod.aggregationTimeInterval.amount
    );
    const [period, setPeriod] = useState(
        currentPeriod.aggregationTimeInterval.period
    );
    useEffect(() => {
        setAmount(currentPeriod.aggregationTimeInterval.amount);
        setPeriod(currentPeriod.aggregationTimeInterval.period);
    }, [currentPeriod]);


    useEffect(() => {
        pageStore.setPeriodOption({
            title: currentPeriod.title,
            aggregationTimeInterval: {
                amount: amount,
                period: period,
            },
            from: currentPeriod.to,
            to: currentPeriod.from,
            periodName: currentPeriod.periodName
        });

        generalStore.showSnackbar({
          type: SnackbarType.success,
          title: t("general:labelOfUpdating")
        });



    }, [amount, period]);

    return (
        <FormControl fullWidth variant="outlined" mt={5}>
            <InputLabel htmlFor="aggregationIntervalSelect">
                {t("general:interval")}
            </InputLabel>
            <Select
                inputProps={{
                    id: "aggregationIntervalSelect",
                }}
                value={period}
                onChange={changeEventHandlerDecorator(setPeriod)}
                input={<OutlinedInput labelWidth={173}/>}
            >
                {Object.values(AggregationPeriod).map((prd) => {
                    return (
                        <MenuItem value={prd} key={prd}>
                            {translate(prd, t)}
                        </MenuItem>
                    );
                })}
            </Select>
            <Space size={5}/>
            <TextField
                label={t("general:detailing")}
                inputProps={{ min: 1 }}
                onChange={changeEventHandlerDecorator(setAmount)}
                variant="outlined"
                type="number"
                value={amount}
            />
        </FormControl>
    );
};

export default observer(AggregationIntervals);
